﻿/*---[ ESLint ]---*/
/*
    global alarmlog
*/

window.alarmlog = function () {

    var LABEL_ETooManyDays = "";
    var LABEL_ENoDataFound = "";
    var dateTimeErrorMessageLabel = "";

    return {

        initialize: function (ETooManyDays, ENoDataFound, dateTimeErrorMessage) {
            LABEL_ETooManyDays = ETooManyDays;
            LABEL_ENoDataFound = ENoDataFound;
            dateTimeErrorMessageLabel = dateTimeErrorMessage;

            main.setHideDiv("errorMessage", false);
            main.setHideDivBootstrap("periodSelector", false);
            
            alarmlog.searchButtonClicked();
        },

        searchButtonClicked: function () {
            $("#SearchButtonLoader").show();

            main.setHideDiv("DivLblTooMany", false);
            main.setHideDiv("DivGridMsg", false);
            main.setHideDiv("errorMessage", false);

            var selectedInterval = parseInt($("#TimeIntervalID").data("kendoDropDownList").value());
            var from = timeinterval.GetBeginPeriodSelection(selectedInterval);
            var to = timeinterval.GetEndPeriodSelection(selectedInterval);

            if (from != null && to != null) {
                var grid = $("#AlarmLogGrid").data("kendoGrid");
                if (grid != null && grid != undefined) {
                    grid.pager.dataSource.page(1);
                    grid.dataSource.read();
                }
            }
            else {
                $("#SearchButtonLoader").hide();
                // make a message
                main.setHideDiv("errorMessage", true);

                var lblError = $("#errorMessageLabel");
                if (lblError != null && lblError != undefined) {
                    lblError.text(dateTimeErrorMessageLabel);
                }
            }
        },

        getAdditionalData: function () {            

            // defaults
            var beginDateTime = moment();
            var toLocal = new Date(beginDateTime.unix() * 1000);
            var fromLocal = new Date(beginDateTime.subtract(1, 'days').unix() * 1000);
            var groupId = null;

            // group
            var cbbGroups = $("#CBB_Group").data("kendoDropDownList");
            if (cbbGroups != null && cbbGroups != undefined) {
                groupId = parseInt(cbbGroups.value()) || null;
            }

            // timeinterval
            var ddl = $("#TimeIntervalID").data("kendoDropDownList");
            if (ddl != null && ddl != undefined) {
                var cbbval = parseInt(ddl.value());
                fromLocal = timeinterval.GetBeginPeriodSelection(cbbval);
                toLocal = timeinterval.GetEndPeriodSelection(cbbval);

                var tsDays = (toLocal - fromLocal) / (1000 * 3600 * 24);
                if (tsDays < 0 || tsDays >= 33) {

                    // make a message
                    main.setHideDiv("DivLblTooMany", true);

                    var lblEmsg = $("#LblTooMany");
                    if (lblEmsg != null && lblEmsg != undefined) {
                        lblEmsg.text(LABEL_ETooManyDays);
                    }

                    fromLocal = toLocal = new Date(Date.now());
                }
            }

            return {
                groupId: groupId,
                timestampFrom: fromLocal,
                timestampTo: toLocal,
            };
        },

        onChangeTimeInterval: function (e) {
            var show = e.sender.element[0].value == timeIntervalEnum.AskedPeriod;
            main.setHideDivBootstrap("periodSelector", show);
        },

        onDataBound: function (e) {
            $("#SearchButtonLoader").hide();

            if (e.sender.dataSource.view().length < 1) {
                main.setHideDiv("DivGridMsg", true);
                var lblEmsg = $("#LblGridMsg");
                if (lblEmsg != null && lblEmsg != undefined) {
                    lblEmsg.text(LABEL_ENoDataFound);
                }
            }
        }
    }
}();